import gql from 'graphql-tag';

export default gql`
  query IsOnboarded {
    onboarded @client
  }
`;



// WEBPACK FOOTER //
// ./src/@data/withOnboarding/query.js